<template>
  <div class="Trio-congrats">
    <div class="Trio-congrats-box">
      <p class="Trio-contgrats-text">
        Muy pronto uno de nuestros expertos hipotecarios se pondrá en contacto
        contigo de forma gratuita y sin compromiso.
      </p>
    </div>
    <button-next @clicked="toStart">Cerrar</button-next>
  </div>
</template>

<script>
import buttonNext from "./buttonNext.vue";

import { Store } from "../store/index";
export default {
  name: "Congratulations",
  components: { buttonNext },
  methods: {
    toStart() {
      Store.commit("ui/CLEAR_ALL");
      Store.commit("personalData/CLEAR_ALL");
      Store.commit("mortgageData/CLEAR_ALL");
      Store.commit("affordData/CLEAR_ALL");
    },
  },
};
</script>